import router from '../router'
export const order = {
    state: {
        status: 'idle',
        paymentUrl: '',
        slug: ''
    },
    mutations: {
        SET_ORDER_STATUS(state, status) {
            state.status = status
        },
        SET_ORDER_PAYMENT_URL(state, paymentUrl) {
            state.paymentUrl = paymentUrl
        },
        SET_ORDER_SLUG(state, slug) {
            state.slug = slug
        }
    },
    actions: {
        resetOrderStatus({ commit }) {
            commit('SET_ORDER_STATUS', 'idle')
        },
        submitOrder({ commit }, payload) {
            commit('SET_ORDER_STATUS', 'sending')
            return new Promise((resolve, reject) => {
                this.$api.post('b2b/v2/orders/checkout', payload).then(response => {
                    if(response.data.data.payment_url !== '') {
                        commit('SET_ORDER_PAYMENT_URL', response.data.data.payment_url)
                        commit('SET_ORDER_SLUG', response.data.data.slug)
                        if(Object.prototype.hasOwnProperty.call(response.data.data, 'script') && response.data.data.script !== '') {
                            const script = response.data.data.script
                            const regexp = /(\S+)=["']?((?:.(?!["']?\s+(?:\S+)=|\s*\/?[>"']))+.)["']?/ig
                            const head = document.getElementsByTagName('head')[0]
                            const scriptTag = document.createElement('script')
                            let result
                            while((result = regexp.exec(script)) !== null) {
                                scriptTag.setAttribute(result[1], result[2])
                            }
                            head.appendChild(scriptTag)
                            const checkPayu = new Promise((resolve, reject) => {
                                let iteration = 0
                                const interval = setInterval(() => {
                                    if(typeof window.PayU === 'object') {
                                        clearInterval(interval)
                                        resolve()
                                    } else {
                                        iteration++
                                    }
                                    // after 5s
                                    if(iteration > 20) {
                                        clearInterval(interval)
                                        reject(new Error('Cannot find PayU object.'))
                                    }
                                }, 250)
                            })
                            // run promise
                            return checkPayu.then(() => {
                                document.getElementById('pay-button').click()
                                commit('SET_ORDER_STATUS', 'paymentInProgress')
                                resolve()
                            }).catch(error => {
                                console.error(error)
                                commit('SET_ORDER_STATUS', 'error')
                                reject(error)
                            })
                        } else {
                            this.$vue.nextTick(() => {
                                document.getElementById('pay-button').click()
                                commit('SET_ORDER_STATUS', 'paymentInProgress')
                                resolve()
                            })
                        }
                    } else {
                        router.push({ name: 'thank-you' }).catch(() => {})
                        resolve()
                    }
                }).catch(error => {
                    reject(new Error(error.response.data.data.error))
                })
            })
        }
    },
    getters: {
        orderStatus: (state) => {
            return state.status
        },
        orderPaymentUrl: (state) => {
            return state.paymentUrl
        },
        orderSlug: (state) => {
            return state.slug
        }
    }
}
